var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGameTokenIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Game_Token_icon_svg__clip0_4_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 272.083c-142.012 0-257.143 115.131-257.143 257.143 0 142.012 115.131 257.143 257.143 257.143 142.012 0 257.143-115.131 257.143-257.143 0-142.012-115.131-257.143-257.143-257.143z",
    fill: "#FED425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 272.083a259.293 259.293 0 00-41.405 3.322c.203.035.417.059.619.095L254.071 604.571c8.203 26.786 20.655 51.715 36.572 74L541.917 275.5a258.82 258.82 0 00-41.929-3.417H500zM358.81 744.155a256.308 256.308 0 0057.285 28.202l265.226-425.452a258.073 258.073 0 00-50.511-39.083l-272 436.333z",
    fill: "#FFE888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 272.083c-142.012 0-257.143 115.131-257.143 257.143 0 142.012 115.131 257.143 257.143 257.143 142.012 0 257.143-115.131 257.143-257.143 0-142.012-115.131-257.143-257.143-257.143zm0 466.667c-115.536 0-209.524-93.988-209.524-209.524S384.464 319.702 500 319.702c4.702 0 9.369.167 14 .477L386.107 525.536l104-.703-90.369 143.715 227-185.941c9.631-7.881 4-23.488-8.44-23.417l-89.143.5 71.143-114.357c65.035 35.607 109.238 104.691 109.238 183.917 0 115.536-93.988 209.524-209.524 209.524l-.012-.024z",
    fill: "#FEDF5B",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.679 744.345c0-36.94-29.953-66.893-66.893-66.893 36.94 0 66.893-29.952 66.893-66.892 0 36.94 29.952 66.892 66.892 66.892-36.94 0-66.892 29.953-66.892 66.893zM525.167 338.976c0-36.94-29.953-66.893-66.893-66.893 36.94 0 66.893-29.952 66.893-66.893 0 36.941 29.952 66.893 66.892 66.893-36.94 0-66.892 29.953-66.892 66.893zM628.655 558.143c0-36.941-29.953-66.893-66.893-66.893 36.94 0 66.893-29.952 66.893-66.893 0 36.941 29.952 66.893 66.893 66.893-36.941 0-66.893 29.952-66.893 66.893z",
    fill: "#fff",
    stroke: "#CAE0E3",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Game_Token_icon_svg__clip0_4_8"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameTokenIcon);
export default ForwardRef;